<template>
    <ion-toolbar class="shift-toolbar">
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack('userForm')">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Create a Shift</ion-title>
      <!-- <ion-buttons slot="end">
        <ion-button @click="submit('userForm')" :disabled="isNextButtonDisabled">
          <span>Post</span>
        </ion-button>
      </ion-buttons> -->
    </ion-toolbar>

    <div class="main_wrapper radio-outer ion-padding">
      <!-- <div>
        <div class="title choose-grp">Choose how you want Locums to take shifts</div>
      </div> -->
      <div class="container onboarding">
        <div class="auth-header">
            <div class="auth-heading">
              <h1>Shift Application</h1>
              <p class="auth-subtext">Choose how you would like the {{ $filters.systemLocumName(false, false) }} to select the shift</p>
            </div>
            <div class="brand-icon" >
                <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
              </div>
          </div>
        <el-form
          class="full_page"
          :model="formsData.userForm"
          :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)"
          :label-position="'top'"
          @submit.prevent="submit('userForm')">
          <div class="flex items-center text-sm">
            <el-radio-group v-model="formsData.userForm.shift_application_type.value" @change="updateVisibilityAccess">
              <template
                v-for="visibilityOption in visibiltyOptions"
                :key="visibilityOption.value"
                style="margin-bottom: 1rem">
                <el-form-item>
                  <el-radio :label="visibilityOption.value" size="large" :disabled="!visibilityOption.visibility">
                  <!-- <el-radio :label="visibilityOption.value" size="large"> -->
                    <p class="main-label">{{ visibilityOption.label }}</p>
                    <p class="sub-label">{{ visibilityOption.description }}</p>
                    <el-item v-if="formsData.userForm.shift_application_type.value ==='2'">
                      <div class="shift-access-select" v-if="visibilityOption.value === '2'">
                        <div class="select-label">Must apply if outside of</div>
                        <el-select
                          v-model="formsData.userForm.application_radius.value"
                          placeholder="Select"
                          size="large">
                          <el-option v-for="item in radiusValue" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                        <!-- TODO validation -->
                        <span v-if="formsData.userForm.shift_application_type.value == 2 && formsData.userForm.application_radius.value == undefined && visibilityOption.value == 2" style="color: red; font-size: 14px; line-height: 1; margin-bottom: 0; margin-top: 8px;">Radius is required</span>
                      </div>
                    </el-item>
        
                      <p v-if="isDateWithin72HoursPresent && visibilityOption.visibility && (visibilityOption.value == 1 || visibilityOption.value == 2)" class="red">
                        Not Recommended for Urgent Shifts (within 72 hours)
                      </p>
        
                  </el-radio>
        
                </el-form-item>
              </template>
            </el-radio-group>
          </div>
        </el-form>
        <div class="background-circles">
            <div class="circle circle-2"></div>
            <div class="circle circle-1"></div>
            <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
          </div>
        <el-button class="primary mt-auto w-full" @click="submit('userForm')" :disabled="isNextButtonDisabled">Post</el-button>
      </div>
    </div>
</template>

<script>
import { onMounted, ref, inject, reactive, getCurrentInstance,computed } from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import formHooks from "@/hooks/form/form";
import { ElMessage } from "@/components/Vendor/Element";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import SvgIcon from '@/components/Svg/SvgIcon.vue';
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon, IonTitle } from "@ionic/vue";

import { useStore } from "vuex";
import {
  useRouter,
  // useRoute
} from "vue-router";
import distanceInMiles from "@/helpers/distance/distance-in-miles.js";
export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    SvgIcon
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const jobCreatePageData = $store.getters.getJobCreatePageData;
    const userRootData = $store.getters.GET_USER_DATA;
    const isDateWithin72HoursPresent = ref(false)
    const showError = ref(false)
    const subscription = ref(
      userRootData.calculatedSubscriptions.subscription ? userRootData.calculatedSubscriptions.subscription : false
    );
    const instance = getCurrentInstance();
    const user = userRootData.shiftVisibilityPercent;
    const isAustralia = isAustraliaRegion();

    const showDialog = ref(false);

    function parseDate(dateString) {
      const [day, month, year] = dateString.split('/').map(Number);
      // console.log(dateString);
      return new Date(year, month - 1, day); // Month is zero-based in JavaScript dates
    }
    const dateArray = jobCreatePageData.dates;

    dateArray.forEach((dateString) => {
      const currentDate = new Date();
      
      const targetDate = parseDate(dateString);
      const timeDifference = targetDate - currentDate;
      
      if (timeDifference <= 72 * 60 * 60 * 1000) {
        isDateWithin72HoursPresent.value = true;
      }
    });


    const visibiltyOptions = [
      {
        label: "First Come, First Served",
        value: "0",
        description: `${instance?.appContext.config.globalProperties.$filters.systemLocumName(true, false) }s can "take" the shift`,
        radioOption: "first_come_first_served",
        visibility: true,
      },
      {
        label: "Apply when outside of radius",
        value: "2",
        description:
          `Useful for regional pharmacies wanting to negotiate with ${instance?.appContext.config.globalProperties.$filters.systemLocumName(false, false) }s outside of a specific radius e.g.${distanceInMiles(200,'km',false)}`,
        radioOption: "apply_radius",
        visibility: true,
      },
      {
        label: "Always Apply",
        value: "1",
        description: `All ${instance?.appContext.config.globalProperties.$filters.systemLocumName(false, false) }s must apply for the shift`,
        radioOption: "always_apply",
        visibility: subscription.value,
      },
    ];

    const radiusValue = [
      {
        value: "50",
        label: isAustralia.value ? "50 km" : "50 miles",
      },
      {
        value: "100",
        label: isAustralia.value ? "100 km" : "100 miles",
      },
      {
        value: "200",
        label: isAustralia.value ? "200 km" : "200 miles",
      },
      {
        value: "300",
        label: isAustralia.value ? "300 km" : "300 miles",
      },
      {
        value: "500",
        label: isAustralia.value ? "500 km" : "500 miles",
      },
    ];

    const formsDataArray = reactive({
      userForm: {
        shift_application_type: {
          value: jobCreatePageData.shift_application_type ? jobCreatePageData.shift_application_type : '0',
        },
        application_radius: {
          value: jobCreatePageData.application_radius ? jobCreatePageData.application_radius : null,
        },
      },
    });

    const goBack = (formName) => {
      $store.dispatch("setJobCreatePageData", getFormValues(formName));
      $router.push({
        name: "multiple_shift_visibility",
      });
    };

    const updateVisibilityAccess = () => {
      const selectedField = formsData.userForm.shift_application_type.value;

      if (selectedField === '2') {
        formsData.userForm.shift_application_type.value = "2";
        formsData.userForm.application_radius.value = radiusValue.find(
          (option) => option.value === selectedField
        )?.value;

      } else if (selectedField === '1') {
        formsData.userForm.shift_application_type.value = "1";
        formsData.userForm.application_radius.value = null;
      } else if (selectedField === '0') {
        formsData.userForm.shift_application_type.value = "0";
        formsData.userForm.application_radius.value = null;
      }
    };

    onMounted(() => {
      setFormRefs();
      setPageClassGlobal("global_job_create_page_visibility");
    });

    const submit = (formName) => {
      if (formsData.userForm.shift_application_type.value === '2' && (formsData.userForm.application_radius.value === null || formsData.userForm.application_radius.value === undefined)) {
        return showError.value = true;
      } else if(formsData.userForm.application_radius.value){
        showError.value = false;
      }

      console.log("FOMR VALUES:", getFormValues(formName));
      formsRefs[formName].value.validate((valid) => {
        console.log("check", formsRefs[formName]);
        if (valid) {
          (async () => {
            try {
              $store.dispatch("setJobCreatePageData", getFormValues(formName));
              await $store.dispatch("ADD_JOB");
              $store.dispatch("clearJobCreatePageData");
              ElMessage({
                type: "success",
                message: "Thank You! Your shift has been successfully posted.",
              });
              $router.push({
                name: "search",
              });
            } catch (error) {
              console.log(error);
              console.log("error submit!!");
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };


    const isNextButtonDisabled = computed(() => {
     
      if (
        formsData.userForm.shift_application_type.value == 2 &&
        (formsData.userForm.application_radius.value == null ||
          formsData.userForm.application_radius.value == undefined)
      ) {
        return true;
      }

      // All validations passed
      return false;
    });


    const { getFormValues, setFormRefs, formsData, formsRefs } = formHooks(formsDataArray);

    return {
      formsData,
      goBack,
      submit,
      visibiltyOptions,
      userRootData,
      user,
      showDialog,
      subscription,
      updateVisibilityAccess,
      radiusValue,
      showError,
      isDateWithin72HoursPresent,
      isAustralia,
      isNextButtonDisabled
    };
  },
};
</script>

<style scoped></style>
